module dg {
    angular.module('dg', [
        'dg.templates',
        'dg.exceptions',
        'dg.uiRouter',
        'dgUtils',
        'dg.clients',
        'dg.restfulApi',
        'dg.loading',
        'dg.navigation',
        'dg.lists',
        'dg.objects',
        'dg.modals',
        'dg.actions',
        'dg.files']);
}